import Image from 'next/image'

export default function ProductsSupplyChainSection() {
  return (
    <section className='mx-auto grid grid-cols-12 gap-5 px-4 py-10 md:gap-5 md:px-16 md:py-20'>
      <div className='text-heading-5 md:text-heading-2 col-span-12 mb-4 text-center leading-[1.2] md:mb-10'>
        Sản Phẩm & <br className='md:hidden' /> Chuỗi Cung Ứng
      </div>
      <div className='col-span-12 grid grid-cols-1 gap-5 md:grid-cols-3'>
        <div className='text-base md:pt-10 md:text-2xl'>
          <strong>Coolmate</strong> sở hữu chuỗi cung ứng riêng, kiểm soát chặt
          chẽ từ R&D đến logistics. Năng lực này được tối ưu hóa để đáp ứng nhu
          cầu khách hàng ngày càng cao. Coolmate tập trung vào:
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip2_45.png'
            alt='Sản Phẩm & Chuỗi Cung Ứng'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip0_36.png'
            alt='Sản Phẩm & Chuỗi Cung Ứng'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip4_84.png'
            alt='Sản Phẩm & Chuỗi Cung Ứng'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip3_56.png'
            alt='Sản Phẩm & Chuỗi Cung Ứng'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip1_79.png'
            alt='Sản Phẩm & Chuỗi Cung Ứng'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
      </div>
    </section>
  )
}
